export const projectStatusList = [
  { label: "New", slug: "new" },
  { label: "Ongoing", slug: "ongoing" },
  { label: "On Hold", slug: "on_hold" },
  { label: "Will Start Later", slug: "will_start_later" },
  { label: "Completed", slug: "completed" },
  { label: "Cancelled", slug: "cancelled" },
  { label: "Pending Approval", slug: "pending_approval" },
  { label: "In Review", slug: "in_review" },
  { label: "Delayed", slug: "delayed" },
  { label: "Other", slug: "other" },
];
